import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Quotation } from './quotation';
import { Requirement } from './requirement';
 import { environment } from '../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class QuotationService {
	baseUrl = environment.baseUrl;
  private quotationUrl = this.baseUrl + '/api/quotation';  // URL to web api
  private requirementUrl = this.baseUrl + '/api/requirement';  // URL to web api
  private getRequirementDetailsUrl = this.baseUrl +'/api/requirement/GetRequirementDetails'; 
     private getquotationDetailsUrl = this.baseUrl +'/api/quotation/GetQuotationDetails'; 
   
  constructor( 
    private http: HttpClient
  ) { }
 
  getRequirements (): Observable<Requirement[]> {
    return this.http.get<Requirement[]>(this.requirementUrl)
  }
 
  getRequirement(requirementid: number): Observable<Requirement> {
    const url = `${this.requirementUrl}/${requirementid}`;
    return this.http.get<Requirement>(url);
  }
  
  /* PO Details */
  GetRequirementDetails(requirementid: number): Observable<Requirement> {
    const url = `${this.getRequirementDetailsUrl}/${requirementid}`;
    return this.http.get<Requirement>(url);
  } 

  /*PO status for PO Approver detail page */
//   GetPoStatus (): Observable<Quotation[]> {
//     return this.http.get<Quotation[]>(this.GetPoStatusUrl)
//   }  
 
  addRequirement (quotation: Requirement): Observable<Requirement> {
    return this.http.post<Requirement>(this.requirementUrl, quotation, httpOptions);
  }
  
    getQuotation(quotationid: number): Observable<Quotation> {
    const url = `${this.quotationUrl}/${quotationid}`;
    return this.http.get<Quotation>(url);
  }
  
   addQuotation (quotation: Quotation): Observable<Quotation> {
    return this.http.post<Quotation>(this.quotationUrl, quotation, httpOptions);
  }
  
   updateQuotation (quotation: Quotation): Observable<any> {
    return this.http.put(this.quotationUrl, quotation, httpOptions);
  }
  
    GetQuotationDetails(requirementid: number): Observable<Quotation> {
    const url = `${this.getquotationDetailsUrl}/${requirementid}`;
    return this.http.get<Quotation>(url);
  } 
  
   deleteQuotation (quotation: Quotation | number): Observable<Quotation> {
    const quotationid = typeof quotation === 'number' ? quotation : quotation.quotationid;
    const url = `${this.quotationUrl}/${quotationid}`;
 
    return this.http.delete<Quotation>(url, httpOptions);
  }
 
  deleteRequirement (quotation: Requirement | number): Observable<Requirement> {
    const requirementid = typeof quotation === 'number' ? quotation : quotation.requirementid;
    const url = `${this.requirementUrl}/${requirementid}`;
 
    return this.http.delete<Requirement>(url, httpOptions);
  }
 
  updateRequirement (quotation: Requirement): Observable<any> {
    return this.http.put(this.requirementUrl, quotation, httpOptions);
  }

}